import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { TopupInEligibleSVG } from '@svgComponents/TopupInEligibleSVG/TopupInEligibleSVG';
import { FormattedMessage } from 'react-intl';

import DashboardCTA from '../../dashboardComponents/DashboardCTA/DashboardCTA';

export const TopUpDeclined = () => {
    useEffect(() => {
        tracking.ampli.applicationDeclined();
    }, []);

    return (
        <DashboardCTA
            data-testid="top-up-declined"
            icon={<TopupInEligibleSVG />}
            title={
                <FormattedMessage
                    id="_.dashboard_widget.topUpDeclined.title"
                    defaultMessage="Sorry, we can’t approve you for more funds at the moment."
                />
            }
            description={null}
        />
    );
};
